import { LogglyTracker } from 'loggly-jslogger';
import { logglyKey } from './../constants';

const logger = new LogglyTracker();

// Push secret key for logger
logger.push({ 'logglyKey': logglyKey });

export default logger;